import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash'
import TimetoastPropTypes from '../../../constants/timetoast_prop_types'
import Pagination from '../../../components/Pagination'
import Dropzone from '@components/forms/Dropzone'
import PhotoLibraryPage from './photo_library_page'

const PhotoLibrary = props => {
  const {
    loadUserPhotos,
    currentPage,
    apiVersion,
    onPaginate,
    onSelectItem,
    onDeleteItem,
    onSelectFilesToUpload,
    photos,
    pagination,
    photoDeletions,
    uploading,
  } = props

  useEffect(() => {
    loadUserPhotos(currentPage)
  }, [])

  const handlePaginationPageClick = pageNumber => {
    onPaginate(pageNumber)
  }

  const handleItemSelect = photoId => {
    onSelectItem(photoId)
  }

  const handleItemDelete = photoId => {
    onDeleteItem(photoId)
  }

  const getPhotoLibraryPageContent = () => {
    const hasFetched = pagination && !pagination.isFetching
    return (
      <PhotoLibraryPage
        isFetching={!hasFetched}
        photos={photos}
        photoDeletions={photoDeletions}
        onSelect={handleItemSelect}
        onDelete={handleItemDelete}
      />
    )
  }

  const getPaginationContent = () => {
    if (pagination) {
      if (pagination.totalCount > pagination.limitValue) {
        const { currentPage, limitValue, totalCount } = pagination
        const totalPages = Math.ceil(totalCount / limitValue)
        return (
          <Pagination
            onPaginationPageClick={handlePaginationPageClick}
            currentPage={currentPage}
            totalPages={totalPages}
          />
        )
      }
    }
    return null
  }

  const uploadsEnabled = () => {
    // check for presence of global object
    if (
      typeof Timetoast !== 'undefined' &&
      typeof Timetoast.settings !== 'undefined' &&
      typeof Timetoast.settings.uploadsEnabled !== 'undefined'
    ) {
      return Timetoast.settings.uploadsEnabled
    } else {
      return true
    }
  }

  const uploadFiles = files => {
    onSelectFilesToUpload(files)
  }

  const getUploaderContent = () => {
    let content
    if (uploadsEnabled()) {
      content = (
        <Dropzone
          onChange={uploadFiles}
          showProgress={uploading}
          instructionsText="Drag and drop images here or click to upload"
          maxItems={5}
        />
      )
    } else {
      content = <strong>Image uploads are temporarily unavailable.</strong>
    }
    return <div className="photo-library__uploader">{content}</div>
  }
  const paginationContent = getPaginationContent()
  const photoLibraryPage = getPhotoLibraryPageContent()
  const uploader = getUploaderContent()
  return (
    <div className="photo-library">
      {uploader}
      {photoLibraryPage}
      {paginationContent}
    </div>
  )
}

PhotoLibrary.propTypes = {
  currentPage: PropTypes.number.isRequired,
  pagination: TimetoastPropTypes.pagination,
  photos: PropTypes.arrayOf(TimetoastPropTypes.photo),
  onSelectItem: PropTypes.func.isRequired,
  onDeleteItem: PropTypes.func.isRequired,
  onPaginate: PropTypes.func.isRequired,
  loadUserPhotos: PropTypes.func.isRequired,
  photoDeletions: PropTypes.array.isRequired,
  uploading: PropTypes.bool,
  onSelectFilesToUpload: PropTypes.func.isRequired,
  apiVersion: PropTypes.number.isRequired,
}

PhotoLibrary.defaultProps = {
  currentPage: 1,
  onSelectItem: noop,
  onDeleteItem: noop,
  loadUserPhotos: noop,
  photoDeletions: [],
  uploading: false,
  onSelectFilesToUpload: noop,
  apiVersion: 1,
}
export default PhotoLibrary
